<template>
  <div class="main-title__box title__box--txt-black dot">

    <h3 class="text-wrap__small">
      <transition appear
          @appear="enterText"
          @enter="enterText"
          @leave="leaveText">
        <span v-html='subtitle'></span>
      </transition>
    </h3>
    <h2 class="text-wrap">
      <transition appear
          @appear="enterText"
          @enter="enterText"
          @leave="leaveText">
        <span v-html='title'></span>
      </transition>
    </h2>

  </div>
</template>

<script>

export default {
  name: 'MainSectionTitle',
  data () {
    return {

    }
  },
  methods: {
    enterText: function(el, done) {
      TweenMax.fromTo(el, .5,
        { y: '105%'},
        { y: '0%',
        // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
        onComplete: done })
    },
    leaveText: function(el, done) {
      TweenMax.to(el, .5,
        { y: '-105%' ,
        // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
        onComplete: done })
    },
  },
  props: ['title', 'subtitle', 'showChild']
}
</script>



// WEBPACK FOOTER //
// src/components/small-components/MainSectionTitle.vue